import * as React from 'react'

const SvgStatisticIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3890_88271)">
      <path
        d="M15 1.66667C16.8383 1.66667 18.3333 3.16167 18.3333 5V15C18.3333 16.8383 16.8383 18.3333 15 18.3333H5C3.16167 18.3333 1.66667 16.8383 1.66667 15V5C1.66667 3.16167 3.16167 1.66667 5 1.66667H15ZM15 0H5C2.23833 0 0 2.23833 0 5V15C0 17.7617 2.23833 20 5 20H15C17.7617 20 20 17.7617 20 15V5C20 2.23833 17.7617 0 15 0Z"
        fill="white"
      />
      <path
        d="M5.83333 15.0007C5.37333 15.0007 5 14.6282 5 14.1673V9.16732C5 8.70732 5.37333 8.33398 5.83333 8.33398C6.29333 8.33398 6.66667 8.70732 6.66667 9.16732V14.1673C6.66667 14.6282 6.29333 15.0007 5.83333 15.0007Z"
        fill="white"
      />
      <path
        d="M10.0003 15C9.54033 15 9.16699 14.6275 9.16699 14.1667V5.83333C9.16699 5.37333 9.54033 5 10.0003 5C10.4603 5 10.8337 5.37333 10.8337 5.83333V14.1667C10.8337 14.6275 10.4603 15 10.0003 15Z"
        fill="white"
      />
      <path
        d="M14.1663 15.0007C13.7055 15.0007 13.333 14.6282 13.333 14.1673V9.16732C13.333 8.70732 13.7055 8.33398 14.1663 8.33398C14.6272 8.33398 14.9997 8.70732 14.9997 9.16732V14.1673C14.9997 14.6282 14.6272 15.0007 14.1663 15.0007Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3890_88271">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgStatisticIcon
